import styled, { css } from 'styled-components';
import Typography from '../../typography';
import { pxToRem } from '../../../design-tokens/style-utilities';
const COUNTER_OFFSET_INITIAL = 60;
const COUNTER_OFFSET_TABLET = 60;
/**
 * Gallery counter
 */
export const galleryCounterContainerStyles = ({ theme, $allowFullscreen, }) => css `
	width: 100%;
	height: auto;
	top: calc(100% - ${pxToRem(COUNTER_OFFSET_INITIAL)});
	grid-area: slide;
	text-align: center;
	position: absolute;
	display: inline-block;

	${$allowFullscreen &&
    css `
		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			top: calc(100% - ${pxToRem(COUNTER_OFFSET_TABLET)});
		}
	`}

	.PONCHO-typography--button-link {
		color: ${theme.colors.blanc.textInverse};
	}
`;
export const GalleryCounterContainer = styled.div `
	${galleryCounterContainerStyles}
`;
/**
 * Gallery counter badge
 */
export const galleryCounterBadgeStyles = ({ theme }) => css `
	background-color: ${theme.colors.base.overlay};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	padding: ${pxToRem(theme.spacing['200'])};
	margin: 0 auto;
	width: auto;
	height: auto;
	text-align: center;
	display: inline-block;
	color: ${theme.colors.blanc.textInverse};
`;
export const GalleryCounterBadge = styled(Typography).attrs({
    variant: 'label-title',
    tagName: 'span',
}) `
	${galleryCounterBadgeStyles}
`;
